function normalizeMountedValue(value) {
  if (value === false || value === 0 || value === "0") return false;
  if (value === true || value === 1 || value === "1") return true;
  return null;
}

function isMobileMounted(value) {
  return normalizeMountedValue(value) === false;
}

function hasMobileTypeTag(tag) {
  return /^\s*type\s*:\s*mobile\s*$/i.test(tag || "");
}

function canAssignBeaconsToClusterTag(items, tag) {
  const hasMobileBeacon = (items || []).some(item => item && item.type === "beacon" && isMobileMounted(item.mounted));
  return !hasMobileBeacon || hasMobileTypeTag(tag);
}

module.exports = {
  canAssignBeaconsToClusterTag,
  normalizeMountedValue,
  isMobileMounted,
  hasMobileTypeTag,
};
